const DefaultComponentStyler = {
  props: {
    block: { type: Boolean, default: false },
    center: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    size: { type: Boolean, default: false },
    height: { type: String, default: undefined },
    width: { type: String, default: undefined },
  },
  computed: {
    defaultClass() {
      return [{ "w-full": this.block }, { "m-auto": this.center }];
    },
    defaultStyle() {
      const style = [];
      if (this.width) {
        style.push({ width: this.width });
      }
      if (this.height) {
        style.push({ height: this.height });
      }
      return style;
    },
  },
};
export { DefaultComponentStyler };
export default DefaultComponentStyler;
